module.exports = __webpack_public_path__ + "fonts/TelefonicaWeb-RegularItalic.4b753fa1.eot";